export const gold = "#A0845C";
export const w = {
  bg: "#ffffff", bg2: "#f7f4ef", bg3: "#f0ece4",
  border: "rgba(0,0,0,0.1)", border2: "rgba(0,0,0,0.2)",
  text: "#1a1a1a", text2: "#555", text3: "#999",
};
export const AREAS = ["Faith","Fitness","Family","Finance","Fun","Firm","Friends"];
export const AREA_COLORS = { Faith:"#1A56DB",Fitness:"#057A55",Family:"#E02424",Finance:"#D97706",Fun:"#7E3AF2",Firm:"#0694A2",Friends:"#E74694" };
export const AREA_SUBTITLES = { Faith:"Spiritual growth",Fitness:"Physical health",Family:"Home & loved ones",Finance:"Stewardship",Fun:"Hobbies & rest",Firm:"Career & calling",Friends:"Community" };
export const DIMENSIONS = ["Physical","Intellectual","Environmental","Vocational","Social","Emotional","Spiritual"];
export const PERIODS = ["Daily","Weekly","Monthly","Quarterly","Annual"];
export const DAYS = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
export const HOURS = ["5am","6am","7am","8am","9am","10am","11am","12pm","1pm","2pm","3pm","4pm","5pm","6pm","7pm","8pm","9pm"];
export const SCRIPTURE = {
  plan: { text:"Commit to the Lord whatever you do, and he will establish your plans.", ref:"Proverbs 16:3" },
  act: { text:"Make the best use of the time, because the days are evil.", ref:"Ephesians 5:16" },
  review: { text:"Let us examine our ways and test them, and let us return to the Lord.", ref:"Lamentations 3:40" },
  adjust: { text:"Plans fail for lack of counsel, but with many advisers they succeed.", ref:"Proverbs 15:22" },
  finance: { text:"The earth is the Lord's, and everything in it.", ref:"Psalm 24:1" },
  journal: { text:"For we are God's handiwork, created in Christ Jesus to do good works.", ref:"Ephesians 2:10" },
  deepdive: { text:"Know well the condition of your flocks, and give attention to your herds.", ref:"Proverbs 27:23" },
  modules: { text:"Now there are varieties of gifts, but the same Spirit.", ref:"1 Corinthians 12:4" },
};
export const TABS = [
  { id:"plan", label:"Plan", icon:"◎" },
  { id:"act", label:"Act", icon:"◷" },
  { id:"review", label:"Review", icon:"◈" },
  { id:"adjust", label:"Adjust", icon:"◉" },
  { id:"finance", label:"Finance", icon:"◐" },
  { id:"deepdive", label:"Deep Dive", icon:"◭" },
  { id:"modules", label:"Modules", icon:"◫" },
  { id:"journal", label:"Journal", icon:"◑" },
];
export const PDF_SECTIONS = [
  { id:"plan", label:"Plan — Vision & Goals" },
  { id:"act", label:"Act — Priorities & Time Map" },
  { id:"review", label:"Review — Life Wheel & Reflection" },
  { id:"adjust", label:"Adjust — Strategic Changes" },
  { id:"finance", label:"Finance — Stewardship Dashboard" },
  { id:"deepdive", label:"Deep Dive — Area Handles & Assessments" },
  { id:"journal", label:"Journal — Prayer Notes" },
];
